var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4,
    y2: 4,
    transform: "translate(5 5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 4,
    y2: 4,
    transform: "translate(5 5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelWhiteIcon);
export default __webpack_public_path__ + "static/media/cancel-white-icon.7c4c06e7bcf7488e6b6c580f5d7fcd62.svg";
export { ForwardRef as ReactComponent };